import { lazy } from "react";

const RELOAD_FLAG_KEY = "explosion-chunk-reload-attempted";

/**
 * Come React.lazy, ma se il chunk fallisce a caricare (es. dopo un deploy: l'hash del
 * file è cambiato e il browser ha ancora in cache un bundle vecchio che punta a un chunk
 * non più esistente sul server → ChunkLoadError) ricarica automaticamente la pagina UNA
 * sola volta per prendere il bundle aggiornato, invece di restare bloccata silenziosamente.
 * Bug reale osservato: un cliente con un link email aperto da prima di un deploy non
 * riusciva più ad accettare un preventivo, perché il click apriva un chunk lazy ormai
 * inesistente e la richiesta non partiva mai.
 */
export function lazyWithRetry(importer) {
  return lazy(() =>
    importer()
      .then((module) => {
        sessionStorage.removeItem(RELOAD_FLAG_KEY);
        return module;
      })
      .catch((error) => {
        if (!sessionStorage.getItem(RELOAD_FLAG_KEY)) {
          sessionStorage.setItem(RELOAD_FLAG_KEY, "1");
          window.location.reload();
          return new Promise(() => {}); // il reload interrompe comunque l'esecuzione
        }
        throw error;
      })
  );
}
